import { createStore } from '@zen/common-app-parts';
import useSearchStore from './modules/useSearchStore';

const { Provider, useStore } = createStore({
  useStoreHook: useSearchStore,
  contextDisplayName: 'DexSearchStoreContext',
});

export default {
  /**
   * @type {DexSearchStoreProvider}
   */
  Provider,
  /**
   * @type {UseDexSearchStore}
   */
  useStore,
};

/**
 * @typedef {({ dbClient: Object }) => void} DexSearchStoreProvider
 */

/**
 * @typedef {() => DexSearchStore} UseDexSearchStore
 */

/**
 * @typedef {{
 *  state: {
      edit: {
        base: {
          value: string,
          valid: boolean,
        },
        quote: {
          value: string,
          valid: boolean,
        },
      },
      base: string,
      quote: string,
      searching: boolean,
      orders: {},
    },
    actions: {
      setBase: (base: string) => void,
      setQuote: (quote: string) => void,
      search: ({base: string, quote: string}) => Promise<void>,
      reset () => void,
    }
 * }} DexSearchStore
 */
